import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import FormForgotPasswordResetView from './FormForgotPasswordReset-view';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';


const FormForgotPasswordReset = ({goNext, contextActions}) => {
  const initialValues = {
    verificationCode: ''
  };

  const validate = values => checkRequiredValues(values, {});

  const handleSubmit = values => {
    const {verificationCode} = values;
    contextActions.pushStepContext({verificationCode});
    goNext();
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <FormForgotPasswordResetView
          {...formikProps}
        />
      )}
    </Formik>
  )
};

FormForgotPasswordReset.propTypes = {
  goNext: PropTypes.func,
  contextActions: PropTypes.object
};

export default FormForgotPasswordReset;
